import { createSlice } from "@reduxjs/toolkit";
import { MemberDeletionRequestResponse } from "./contracts/MemberDeletionRequestResponse";
import {
  dismissDeletionRequest,
  eraseDeletionRequest,
  fetchDeletionRequests,
} from "./slice-extensions/deletion-requests-slice-extension";

interface DeletionRequestsState {
  requests: MemberDeletionRequestResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
}

const initialState: DeletionRequestsState = {
  requests: [],
  status: "idle",
};

const applyDecision = (
  state: DeletionRequestsState,
  requestId: string,
  status: string,
) => {
  state.requests = state.requests.map((request) =>
    request.id === requestId
      ? { ...request, status, decidedAt: new Date().toISOString() }
      : request,
  );
};

const deletionRequestsSlice = createSlice({
  name: "deletionRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeletionRequests.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDeletionRequests.fulfilled, (state, action) => {
        state.requests = action.payload.items;
        state.status = "succeeded";
      })
      .addCase(fetchDeletionRequests.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(eraseDeletionRequest.fulfilled, (state, action) => {
        applyDecision(state, action.payload.requestId, "Erased");
      })
      .addCase(dismissDeletionRequest.fulfilled, (state, action) => {
        applyDecision(state, action.payload, "Dismissed");
      });
  },
});

export const selectDeletionRequests = (state: { deletionRequests: DeletionRequestsState }) =>
  state.deletionRequests.requests;

export const selectDeletionRequestsStatus = (state: {
  deletionRequests: DeletionRequestsState;
}) => state.deletionRequests.status;

export default deletionRequestsSlice.reducer;
